import axios from 'axios';
import BlumarConfig from '../blumar-config';
import store from '../store/store';

export default function executeInterceptor() {
  axios.defaults.baseURL = BlumarConfig.baseApiUrl;
  axios.interceptors.request.use(config => {
    const token = window.localStorage.getItem('token')
    if (token && !config.headers.authorization) {
      config.headers.access_key = `13e3bfb0-9605-4839-9e70-0da2080857f0`;
      config.headers.authorization = `Bearer ${token}`;
    }
    // show loader, store instance
    store.dispatch('showLoading', true);
    return config;
  }, error => {
    store.dispatch('showLoading', false);
    return Promise.reject(error);
  });

  axios.interceptors.response.use(response => {
    store.dispatch('showLoading', false);
    return response;
  }, error => {
    store.dispatch('showLoading', false);
    return Promise.reject(error);
  });


};



// WEBPACK FOOTER //
// ./src/service/HttpHelper.js